import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map, Set } from 'immutable';

import { MediaItemEntity } from './media-item.entity';

export interface IMediaListExtra extends IListColumnConfig<MediaItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IMediaListEntity extends IListAttrs<MediaItemEntity> {
	availableColumns: Map<string, IMediaListExtra>;
}

const entityDefaults: IMediaListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class MediaListEntity
	implements
		IMediaListEntity,
		IListOperations<MediaListEntity, MediaItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<IMediaListExtra>): MediaListEntity {
		const instance = new MediaListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IMediaListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<MediaItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, MediaItemEntity>): MediaListEntity {
		return produce(this, (draft: MediaListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mediaItem) => {
			if (!mediaItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...mediaItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mediaItem) => {
			if (mediaItem.updatedByAvatar && mediaItem.updatedByAvatar?.name) {
				acc = acc.add(mediaItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mediaItem) => {
			if (mediaItem.createdByAvatar && mediaItem.createdByAvatar.name) {
				acc = acc.add(mediaItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
